/**
 * Het overzicht van veelgestelde vragen op de gedeelde archiefmachinerie zetten.
 *
 * Eén as: de categorie. De knoppen zijn radio's, dus er staat er hooguit één aan --
 * \App\Faq::archive() leest ?category= dan ook als één slug, en negeert een slug die
 * niet bestaat.
 *
 * Er wordt bij binnenkomst niet naar de lijst gescrold: de filterbalk staat hier vlak
 * boven de vragen en niet ergens halverwege de pagina.
 */

import initArchiveFilter, { setParam } from './archive-filter';

export default function initFaqFilter() {
  initArchiveFilter({
    filter: '[data-faq-filter]',
    results: '[data-faq-results]',
    option: '[data-category-option]',
    all: '[data-category-all]',
    controls: '.faq-checkbox',

    buildUrl(url, filter) {
      const checked = filter.querySelector('.faq-checkbox:checked');

      setParam(url, 'category', checked ? checked.value : '');
    },

    describe: (count) => {
      if (count === 0) {
        return 'Geen vragen gevonden.';
      }

      return count === 1 ? '1 vraag gevonden.' : `${count} vragen gevonden.`;
    },
  });
}
